const PORTFOLIO_1 =
  "https://images.pexels.com/photos/8082243/pexels-photo-8082243.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const PORTFOLIO_2 =
  "https://images.unsplash.com/photo-1613545325268-9265e1609167?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwaW50ZXJpb3IlMjBicmlnaHR8ZW58MHx8fHwxNzgzMzcxMzcxfDA&ixlib=rb-4.1.0&q=85";
const PORTFOLIO_3 =
  "https://images.pexels.com/photos/6466236/pexels-photo-6466236.jpeg";

const items = [
  { img: PORTFOLIO_1, name: "The Terrace Loft", location: "Downtown · 2BR", tag: "Boutique" },
  { img: PORTFOLIO_2, name: "Casa Blanca", location: "Coastal · 3BR", tag: "Villa" },
  { img: PORTFOLIO_3, name: "The Atelier Suite", location: "Arts District · Studio", tag: "Design" },
];

export default function Portfolio() {
  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="relative bg-cream py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <div className="text-xs tracking-[0.3em] uppercase text-brass mb-6">Portfolio</div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-espresso font-light">
              A curated collection of <em className="not-italic text-brass">stays we steward.</em>
            </h2>
          </div>
          <div className="text-espresso/70 text-sm max-w-xs">
            Every home in our portfolio is hand-selected and prepared to a
            consistent, editorial standard.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          <div className="md:col-span-8 group overflow-hidden" data-testid="portfolio-item-0">
            <div className="aspect-[16/10] overflow-hidden">
              <img src={items[0].img} alt={items[0].name} className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
            </div>
            <div className="mt-4 flex items-end justify-between">
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-brass">{items[0].tag}</div>
                <div className="font-serif text-2xl text-espresso mt-1">{items[0].name}</div>
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-taupe">{items[0].location}</div>
            </div>
          </div>

          <div className="md:col-span-4 group overflow-hidden" data-testid="portfolio-item-1">
            <div className="aspect-[3/4] overflow-hidden">
              <img src={items[1].img} alt={items[1].name} className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
            </div>
            <div className="mt-4">
              <div className="text-[10px] tracking-[0.3em] uppercase text-brass">{items[1].tag}</div>
              <div className="font-serif text-2xl text-espresso mt-1">{items[1].name}</div>
              <div className="text-xs uppercase tracking-[0.2em] text-taupe mt-1">{items[1].location}</div>
            </div>
          </div>

          <div className="md:col-span-12 group overflow-hidden" data-testid="portfolio-item-2">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
              <div className="md:col-span-7 aspect-[16/9] overflow-hidden md:order-1 order-2">
                <img src={items[2].img} alt={items[2].name} className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
              </div>
              <div className="md:col-span-5 flex flex-col justify-center md:order-2 order-1">
                <div className="text-[10px] tracking-[0.3em] uppercase text-brass">{items[2].tag}</div>
                <div className="font-serif text-3xl md:text-4xl text-espresso mt-2">{items[2].name}</div>
                <div className="text-xs uppercase tracking-[0.2em] text-taupe mt-2">{items[2].location}</div>
                <p className="text-espresso/70 mt-4 max-w-sm">A refined loft in the heart of the arts district — thoughtfully staged and consistently top-rated by guests worldwide.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
